import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Exact role match (legacy usage: requiredRole="super_admin")
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/admin" />;
  }

  // Allow-list of roles
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/admin" />;
  }

  return children;
};

export default ProtectedRoute;
